import { useEffect } from "react";

import { appStoreBase, defaultStoreId } from "@formant/rectangle-sdk";

import { applyCarriedOverTime, ICarriedOverTime } from "./v1TimeCarryOver";

/**
 * Render after <Editor>: the editor resets the rectangle store to live in a
 * mount effect, and this effect runs after it because it is a later sibling.
 */
export const CarryV1TimeToCoherence = (props: {
    consume: () => ICarriedOverTime | undefined;
}) => {
    useEffect(() => {
        const carried = props.consume();
        if (carried) {
            applyCarriedOverTime(
                carried,
                appStoreBase(defaultStoreId).getState(),
            );
        }
    }, []);
    return null;
};
